// utils/langToContentLangId.ts
import type { Lang } from "locales/i18n";

export const langToContentLangId = (lang: Lang): string => {
	switch (lang) {
		case "en":
			return "1"; // English
		case "ru":
			return "2"; // Russian
		case "tr":
			return "3"; // Turkish
		default:
			return "2"; // default = Russian
	}
};
